export default __webpack_public_path__ + "static/media/icon-card-additional-crew.68f0251a.svg";